import { ProductTile } from "../../types";
import { i18n } from "../i18n";

export const OtherSellersChip = ({
  productTile,
}: {
  productTile: ProductTile;
}) => {
  const getLinkLabel = (sellerCount: number) => {
    if (sellerCount <= 10) {
      return productTile.uniqueSellerCount.toString();
    }

    if (sellerCount > 10) {
      return "10+";
    }

    return "1";
  };

  return (
    <button
      class="js-open-select-seller-menu tw:self-start tw:px-3 tw:py-1 tw:bg-fruugo-off-white tw:rounded-full tw:border tw:border-fruugo-low-key tw:flex tw:items-center tw:gap-2 tw:group tw:m-2 tw:mt-0"
      data-product-id={`${productTile.productId}`}
    >
      <svg class="tw:w-5 tw:h-5 tw:shrink-0" aria-hidden="true">
        <use href="/marketplace/images/sprite-icon.svg#storefront" />
      </svg>
      <p class="tw:m-0">
        <span class="tw:text-fruugo-blue-secondary tw:underline tw:cursor-pointer tw:bg-transparent tw:border-0 tw:p-0 tw:group-hover:no-underline tw:group-focus:no-underline tw:m-0">
          {i18n(
            "product.multi-merchant.availability.link",
            getLinkLabel(productTile.uniqueSellerCount)
          )}
        </span>
      </p>
    </button>
  );
};
